import React from 'react';
import SearchableSelect from './crm/SearchableSelect';
import { COUNTRIES, getStatesForCountry } from '../constants/countries';

const COUNTRY_OPTIONS = COUNTRIES.map(c => ({ _id: c.name, name: c.name }));

// Country dropdown — searchable since the world list is ~190 entries.
export function CountrySelect({ value, onChange, className }) {
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={COUNTRY_OPTIONS}
      placeholder="Select country…"
      className={className}
    />
  );
}

// State/province field — a dropdown when the selected country has a known
// state list (India, US, UAE today), otherwise a free-text input so users in
// any other country can still enter their state/region/province.
export function StateSelect({ country, value, onChange, className }) {
  const countryCode = COUNTRIES.find(c => c.name === country)?.code;
  const states = getStatesForCountry(countryCode);

  if (states.length === 0) {
    return (
      <input
        type="text"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder="State / Province / Region"
        className={className || 'w-full h-10 px-3 bg-[#F3F2F2] border border-[#D8DDE6] rounded text-[13px] outline-none focus:bg-white focus:border-[#0176D3] transition-all'}
      />
    );
  }

  const stateOptions = states.map(s => ({ _id: s, name: s }));
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={stateOptions}
      placeholder="Select state…"
      className={className}
    />
  );
}
